import { Message } from 'element-ui'
export default {
    Alerts(msg,type){
        // type=1是错误
        // type=2是成功
        // type=3是警告
        // type=4是消息
        var types='success'
        switch(type){
            case 1:
                types='error'
                break;
            case 2:   
                types='success'
                break;
            case 3:   
                types='warning'
                break;
            case 4:   
                types='info'
                break;
            default:
                types='success'
                break;
        }
        this.$message({
            type:types,
            offset:0,
            // duration:0,
            message:msg,
            showClose: true,
            // customClass:'selfAlert'
        });
    },
    Delets(func){
        this.$confirm('您确定要删除吗？', '提示', {
            confirmButtonText: '删除',
            cancelButtonText: '取消',
            beforeClose:func
        }).then(()=>{

        }).catch((action)=>{
        })
    },
    //手机号码校验
    /*验证手机号*/
    checkPhone(rule, value, callback){

        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if(value){
            if (reg.test(value)) {
            callback();
            } else {
            return callback(new Error('请输入正确的手机号'));
            }
        }else{
            callback();
        }
        
    },
    valiNumberPass(rule, value, callback){
    //包含小数的数字
        let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g;
        if(value){
            if (!reg.test(value)) {
                callback(new Error('请输入数字'));
            } else {
                callback();
            }
        }else{
            callback();
        }
    },
    oneNumber(rule, value, callback){
        let reg = /^((\d+\.\d)|)$/;
        if(value){
            if (!reg.test(value)) {
                callback(new Error('请输入数字且只能保留一位小数'));
            } else {
                callback();
            }
        }else{
            callback();
        }
    },
    //0-100的数字
    contentNumber(rule, value, callback){
        var reg = /^(\d{1,2}(\.\d{1,3})?|100)$/;
        if(value){
            if (!reg.test(value)) {
                callback(new Error('请输入0-100的数字'));
            } else {
                callback();
            }
        }else{
            callback();
        }
    },
    // 删除对象
    deletesObj(obj,name1){
        for(var i in obj){
            if(i==name1){
                delete obj[i]
            }
        }
        return obj
    },
    //保留两位小数
    cutOutNum(num, decimals){
        if (isNaN(num) || (!num && num !== 0)) {
          return '--'
        }
        // 默认为保留的小数点后两位
        let dec = decimals ? decimals : 2
        let tempNum = Number(num)
        let pointIndex = String(tempNum).indexOf('.') + 1 // 获取小数点的位置 + 1
        let pointCount = pointIndex ? String(tempNum).length - pointIndex : 0 // 获取小数点后的个数(需要保证有小数位)
        // 源数据为整数或者小数点后面小于decimals位的作补零处理
        if (pointIndex === 0 || pointCount <= dec) {
          let tempNumA = tempNum
          if (pointIndex === 0) {
            tempNumA = `${tempNumA}.`
            for (let index = 0; index < dec - pointCount; index++) {
              tempNumA = `${tempNumA}0`
            }
          } else {
            for (let index = 0; index < dec - pointCount; index++) {
              tempNumA = `${tempNumA}0`
            }
          }
          return tempNumA
        }
        let realVal = ''
        // 截取当前数据到小数点后decimals位
        realVal = `${String(tempNum).split('.')[0]}.${String(tempNum)
          .split('.')[1]
          .substring(0, dec)}`
        // 判断截取之后数据的数值是否为0
        if (realVal == 0) {
          realVal = 0
        }
        return realVal
    },
    deepClone(target) {
        // 定义一个变量
        let result;
        // 如果当前需要深拷贝的是一个对象的话
        if (typeof target === 'object') {
        // 如果是一个数组的话
            if (Array.isArray(target)) {
                result = []; // 将result赋值为一个数组，并且执行遍历
                for (let i in target) {
                    // 递归克隆数组中的每一项
                    result.push(deepClone(target[i]))
                }
             // 判断如果当前的值是null的话；直接赋值为null
            } else if(target===null) {
                result = null;
             // 判断如果当前的值是一个RegExp对象的话，直接赋值    
            } else if(target.constructor===RegExp){
                result = target;
            }else {
             // 否则是普通对象，直接for in循环，递归赋值对象的所有值
                result = {};
                for (let i in target) {
                    result[i] = deepClone(target[i]);
                }
            }
         // 如果不是对象的话，就是基本数据类型，那么直接赋值
        } else {
            result = target;
        }
         // 返回最终结果
        return result;
    },
}


// WEBPACK FOOTER //
// ./src/assets/js/common.js